import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { LoginService } from '../../login/login.service';
import { UsersService } from '../users.service';

@Component({
  selector: 'app-user-change-password',
  templateUrl: './user-change-password.component.html',
  styleUrls: ['./user-change-password.component.scss']
})
export class UserChangePasswordComponent implements OnInit {

  public changePswModal: any = {
  };
  public user: any;
  public userId: number;

  constructor(
    private messageService: MessageService,
    private dynamicDialogRef: DynamicDialogRef,
    private userService: UsersService,
    private config: DynamicDialogConfig,
    private loginService: LoginService,
    private usersService: UsersService
  ) { }

  ngOnInit(): void {
    this.userId = this.config.data.id;
    if (this.config.data.user) {
      this.user = this.config.data.user;
    } else {
      this.loadUser();
    }
  };

  loadUser() {
    if (this.userId) {
      this.usersService.get(this.userId).subscribe(
        data => {
          this.user = data;
        },
        error => {
          this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        }
      );
    }
  }

  changePassword() {
    if (this.changePswModal.password != "" && this.changePswModal.password == this.changePswModal.password2) {
      this.user.password = this.changePswModal.password;
      this.userService.changePassword(this.user).subscribe(
        data => {
          //Al final de todas las operaciones, se cierra la pantalla?
          this.dynamicDialogRef.close(data);
          this.messageService.add({ closable: false, severity: 'success', summary: "Contraseña modificada correctamente." });
          //Mandar correo aquí:
          this.notificateChange();
        },
        error => {
          this.messageService.add({ closable: false, severity: "error", detail: error.error.Message });
        }
      );
    }
  }

  notificateChange() {
    this.loginService.notificateChange(this.user.email).subscribe(
      data =>{
        this.messageService.add({ closable: false, severity: 'success', summary: "Correo enviado." });
      },
      error => {
        this.messageService.add({ closable: false, severity: "error", detail: error.error.Message });
      }
    );
  }

  cancel() {
    this.dynamicDialogRef.close();
  }
}
